import { getFabricGroupById } from '@/infrastructure/engine2d/helpers/FabricGroupHelper';
import { CUTTING_SHAPE_ID } from '@/domain/selection/reservedSelectionIds';
import type { Canvas } from 'fabric';

type TCuttingShapeOverlayServiceParams = {
    canvas: Canvas;
};

// Behavior-preserving extraction of the cutting-path canvas concern
// previously handled by FabricScene.deleteCuttingPath and by the
// setCuttingPathVisibility helper in FabricCallbackHelper.
//
// Domain-level cutting-path logic (loading the SVG, turning it into a
// CuttingShape) lives in @/application/controllers/CuttingShapeController
// and is out of scope here — this adapter only owns the canvas-side
// visibility / removal.
class CuttingShapeOverlayService {
    private readonly _canvas: Canvas;

    constructor(params: TCuttingShapeOverlayServiceParams) {
        this._canvas = params.canvas;
    }

    remove(): void {
        const cuttingGroup = getFabricGroupById(this._canvas, CUTTING_SHAPE_ID);
        if (!cuttingGroup) {
            return;
        }
        cuttingGroup.hasControls = false;
        this._canvas.renderAll();
        this._canvas.remove(cuttingGroup);
        cuttingGroup.dispose();
    }

    setOpacity(opacity: number): void {
        const cuttingGroup = getFabricGroupById(this._canvas, CUTTING_SHAPE_ID);
        if (!cuttingGroup) {
            return;
        }
        // Preserved as-is from setCuttingPathVisibility: only apply when the
        // group has been fully clipped (no leftover clipPath on any child).
        const isClipped = cuttingGroup.getObjects().every((obj) => !obj.clipPath);
        if (!isClipped) {
            return;
        }
        cuttingGroup.opacity = opacity;
    }
}

export { CuttingShapeOverlayService };
